'use client';

import React, { createContext, useContext } from 'react';
import type { Session } from 'next-auth';

// Define the shape of our session context
interface SessionContextValue {
  session: Session | null;
}

// Create the context with a default value
const SessionContext = createContext<SessionContextValue>({ session: null });

interface SessionProviderProps {
  session: Session | null;
  children: React.ReactNode;
}

// Provider component that accepts session data and provides it via context
const SessionProvider: React.FC<SessionProviderProps> = ({ session, children }) => (
  <SessionContext.Provider value={{ session }}>
    {children}
  </SessionContext.Provider>
);

// Hook to access the session context from client components
export const useSessionContext = (): SessionContextValue => useContext(SessionContext);

// Export the provider as default for ease of import
export default SessionProvider; 